import React from 'react'
import { useTranslation } from 'next-i18next'
import { MePayout } from '../../../../../types/Payout/MePayout'
import DisplayPayoutRevenues from '../../../../shared/DisplayPayoutRevenues'
import { PayoutTransactionStatus } from '../../../../../types/Payout/PayoutTransactionStatus'
import { PayoutMethodType } from '../../../../../types/Payout'
import { formatDateString } from '../../../../../lib/utils/formatDate'
import useLocale from '../../../../../hooks/useLocale'

interface PayoutsReviewTabElemProps {
  mePayout: MePayout
}

export default function PayoutsReviewTabElem({
  mePayout,
}: PayoutsReviewTabElemProps) {
  const { t } = useTranslation('dashboard')
  const { locale } = useLocale()

  const PayoutStatusTranslations: Record<PayoutTransactionStatus, string> = {
    [PayoutTransactionStatus.NOT_PROCESSED]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.not_processed',
    ),
    [PayoutTransactionStatus.PROCESSING]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.processing',
    ),
    [PayoutTransactionStatus.SENT]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.sent',
    ),
    [PayoutTransactionStatus.ERROR]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.error',
    ),
    [PayoutTransactionStatus.FROZEN]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.frozen',
    ),
    [PayoutTransactionStatus.REQUIRE_MANUAL_ACTION]: t(
      'payoutsReview.tab.columns.payoutTransactionStatus.require_manual_action',
    ),
  }

  const PayoutMethodTypeTranslations: Record<PayoutMethodType, string> = {
    [PayoutMethodType.MULTIVERSX_USDC]: t(
      'payoutsReview.tab.columns.payoutMethod.multiversX',
    ),
    [PayoutMethodType.MULTIVERSX_EURC]: t(
      'payoutsReview.tab.columns.payoutMethod.balance',
    ),
    [PayoutMethodType.REVOLUT_EUR]: t(
      'payoutsReview.tab.columns.payoutMethod.revolut',
    ),
    [PayoutMethodType.PAYPAL_EUR]: t(
      'payoutsReview.tab.columns.payoutMethod.paypal',
    ),
  }

  return (
    <div className="flex items-center">
      <div className="flex items-center space-x-6">
        <div className="flex flex-col">
          <p className="text-lg font-medium text-green-600 md:text-2xl">
            +
            {mePayout.netAmount && (
              <DisplayPayoutRevenues
                revenues={mePayout.netAmount}
                currency={mePayout.userPayoutMethod.payoutMethod.currency}
                digitAfterDecimalPoint={2}
                decimals={2}
              />
            )}
          </p>
          <p className="text-xs font-thin text-gray-700 md:text-sm">
            {PayoutStatusTranslations[mePayout.status]}
          </p>
        </div>
        <div>
          <p className="md:text-md whitespace-nowrap text-sm text-gray-600">
            <strong>
              {
                PayoutMethodTypeTranslations[
                  mePayout.userPayoutMethod.payoutMethod.type
                ]
              }
            </strong>
          </p>
        </div>
      </div>

      <div className="flex grow items-center justify-end">
        <div>
          <p className="md:text-md whitespace-nowrap text-sm text-gray-700">
            {formatDateString(mePayout.updatedAt.toString(), locale)}
          </p>
        </div>
      </div>
    </div>
  )
}
